import { render, staticRenderFns } from "./CdcConnection.vue?vue&type=template&id=23714eb0&scoped=true&"
import script from "./CdcConnection.vue?vue&type=script&lang=js&"
export * from "./CdcConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23714eb0",
  null
  
)

export default component.exports